import { offsetNumberToNumber } from './tokenNumberUtils';

const LEVERAGE_DECIMALS = 2;
const DEFAULT_LEVERAGE = 1;

export const leverageFromHundredths = (leverageHundredths?: number): number => {
  if (leverageHundredths == null) return DEFAULT_LEVERAGE;
  return offsetNumberToNumber(leverageHundredths, LEVERAGE_DECIMALS);
};
